<div *ngIf="form">
    {{ test }}
    <form [formGroup]="form">
        <div class="row mx-0" *ngFor="let supecededProduct of supecededProducts.controls; let i = index">
            <div class="col-12 col-lg-10 d-inline-flex justify-content-between px-0">
                <lib-text-box class="w-100" 
                    [control]="formGroupCast(supecededProduct).controls.partNumber"
                    [label]="'Supersede to:'" 
                    [labelBlock]="true" 
                    [idName]="'name'" 
                    [placeHolder]="'Enter part number - A product prefix is required'" 
                    [labelOpacity]="i == 0 ? '1' : '0'" 
                    [autofocus]="true">
                </lib-text-box>
                <lib-number-box class="ml-3" 
                    [control]="formGroupCast(supecededProduct).controls.quantity"
                    [labelBlock]="false" 
                    [width]="'38px'" 
                    [idName]="'quantiy'" 
                    [label]="''"
                    hidden>
                </lib-number-box>
                <button type="button" class="btn btn-danger p-2 mb-4 ml-3" *ngIf="allowMultipleSupercessions && i > 0" (click)="removeSuperSede(i)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"/>
                    </svg>
                </button>
            </div>
            <div class="col-12 col-lg-10 text-right px-0 add-link" *ngIf="allowMultipleSupercessions && i == (supecededProducts.controls.length - 1)">
                <button (click)="superSedeExist(i, formGroupCast(supecededProduct).controls.exists)" [disabled]="!formGroupCast(supecededProduct).valid"
                    [ngClass]="{'disable-link': !formGroupCast(supecededProduct).valid}">
                    Add another product
                </button>
            </div>
        </div>

        <div class="row mx-0" *ngIf="products?.length">
            <div class="col-12 col-lg-10 d-inline-flex justify-content-between px-0">
                <lib-select-box class="w-100" 
                    [source]="products" 
                    [control]="suggestedForm.controls.suggestion"
                    [fieldDescription]="'description'" 
                    [labelBlock]="true" 
                    [idName]="'suggestion'"
                    [label]="'Suggestions:'">
                </lib-select-box>
                <lib-number-box class="ml-3" 
                    [control]="suggestedForm.controls.suggestionNumber" 
                    [labelBlock]="false"
                    [width]="'38px'" 
                    [idName]="'quantity'" 
                    [label]="''"
                    hidden>
                </lib-number-box>
            </div>
            <div class="col-12 col-lg-10 text-right px-0 add-link" *ngIf="allowMultipleSupercessions">
                <button (click)="appendSuggestedSuperSede()" [disabled]="!addDisableValidation">Add another product</button>
            </div>
        </div>
    </form>
</div>